<template>
    <div class="record-root">
        <Top></Top>
        <div class="record-body___1UbSf finanrec_body">
            <div class="finanrec_crumbs">
                <a @click="changeRoute('/assets/account')">{{ $t('m.assets.nav')[4] }}</a>
                <span class="sep">&gt;</span>
                <span>{{ $t('m.common.newDeal')[7] }}</span>
            </div>
            <div class="side-menu-layout">
                <div class="content_main">
                    <div class="coin_record___2KAq3">
                        <div
                            class="ant-card card___3boob ant-card-bordered ant-card-wider-padding ant-card-padding-transition"
                            style="min-height: 680px;">
                            <div class="ant-card-head">
                                <div class="ant-card-head-wrapper">
                                    <div class="ant-card-head-title">
                                        <div class="ant-tabs ant-tabs-top  kc-tabs ant-tabs-line">
                                            <div class="ant-tabs-bar">
                                                <div class="ant-tabs-nav-container">
                                                    <div class="ant-tabs-nav-wrap">
                                                        <div class="ant-tabs-nav-scroll">
                                                            <div class="ant-tabs-nav ant-tabs-nav-animated">
                                                                <div class="ant-tabs-tab"
                                                                     :class="recordActive == 'recharge' ? 'ant-tabs-tab-active' : ''"
                                                                     @click="recordActive = 'recharge'">{{
                                                                        $t('m.assets.text[5]')
                                                                    }}
                                                                </div>
                                                                <div class="ant-tabs-tab"
                                                                     :class="recordActive == 'withdraw' ? 'ant-tabs-tab-active' : ''"
                                                                     @click="recordActive = 'withdraw'">{{
                                                                        $t('m.assets.text[6]')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ant-card-body" v-show="recordActive == 'recharge'">
                                <div class="filter___2AY3J">
                                    <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                        <div class="label___1yE6x">{{ $t('m.order.time[3]') }}</div>
                                        <div class="kcRangePicker___3QFSs">
                                            <span class="ant-calendar-picker ant-calendar-picker-small">
                                                <el-date-picker
                                                    v-model="timeRange"
                                                    type="daterange"
                                                    @blur="timeSearch()"
                                                    unlink-panels
                                                    :range-separator="$t('m.order.text[1]')"
                                                    :start-placeholder="$t('m.order.text[0]')"
                                                    :end-placeholder="$t('m.order.text[2]')">
                                                </el-date-picker>
                                            </span>
                                            <div class="miniDivider___Wh7bp ant-divider ant-divider-vertical"></div>
                                            <div
                                                class="ant-radio-group ant-radio-group-solid filter-radio-button kc-radio-group">
                                                <label class="kc-radio-btn ant-radio-button-wrapper"
                                                       :class="timeActive == 'day' ? 'ant-radio-button-wrapper-checked' : ''"
                                                       @click="timeSearch2('day')">
                                                    <span>{{ $t('m.order.time[1]') }}</span>
                                                </label>
                                                <label class="kc-radio-btn ant-radio-button-wrapper"
                                                       :class="timeActive == 'month' ? 'ant-radio-button-wrapper-checked' : ''"
                                                       @click="timeSearch2('month')">
                                                    <span>{{ $t('m.order.time[2]') }}</span>
                                                </label>
                                                <!--<label class="kc-radio-btn ant-radio-button-wrapper" :class="timeActive == 'threeMonth' ? 'ant-radio-button-wrapper-checked' : ''" @click="timeActive = 'threeMonth'">
                                                    <span>3个月</span>
                                                </label>
                                                <label class="kc-radio-btn ant-radio-button-wrapper" :class="timeActive == 'oneYear' ? 'ant-radio-button-wrapper-checked' : ''" @click="timeActive = 'oneYear'">
                                                    <span>1年</span>
                                                </label>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                        <div class="label___1yE6x">{{ $t('m.assets.table[0]') }}</div>
                                        <div class=" kc-select  ant-select ant-select-enabled ant-select-allow-clear"
                                             style="width: 100px;background-color: #fff">
                                            <div class="ant-select-selection ant-select-selection--single"
                                                 @click="currencyShow = !currencyShow">
                                                <div class="ant-select-selection__rendered">
                                                    <div class="ant-select-selection__placeholder"
                                                         style="display: block; opacity: 1;height: 24px;line-height: 24px">
                                                        {{
                                                            currencyName == '' ? $t('m.assets.status[1]') : currencyName
                                                        }}
                                                    </div>
                                                    <div class="ant-select-search ant-select-search--inline"
                                                         style="display: none;">
                                                        <div class="ant-select-search__field__wrap">
                                                            <input type="text" class="ant-select-search__field">
                                                            <span class="ant-select-search__field__mirror"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="ant-select-arrow" style="user-select: none;">
                                                <i class="ant-select-arrow-icon"></i>
                                            </span>
                                            </div>
                                            <div class="currency-container" v-if="currencyShow">
                                                <div class="currency-list" v-for="(v,k) in currencyAll" :key="k"
                                                     @click="currencyChange(v.currency_name, v.id)">{{
                                                        v.currency_name
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ant-table-wrapper table___3RU8w ">
                                    <div class="ant-spin-nested-loading">
                                        <div class="ant-spin-container">
                                            <div
                                                class="ant-table ant-table-default ant-table-empty ant-table-scroll-position-left">
                                                <div class="ant-table-body">
                                                    <table>
                                                        <thead class="ant-table-thead">
                                                        <tr>
                                                            <th style="width: 100px">
                                                                <span>{{ $t('m.assets.table[0]') }}</span>
                                                            </th>
                                                            <th style="width: 120px">
                                                                <span>{{ $t('m.assets.table[1]') }}</span>
                                                            </th>
                                                            <th style="width: 160px">
                                                                <span>{{ $t('m.assets.table[2]') }}</span>
                                                            </th>
                                                            <th>
                                                                <span>{{ $t('m.assets.text[12]') }}</span>
                                                            </th>
                                                            <th>
                                                                <span>{{ $t('m.assets.table[3]') }}</span>
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="ant-table-tbody">
                                                        <tr v-for="(v,k) in rechargeList" :key="k">
                                                            <td><span>{{ v.currency_name }}</span></td>
                                                            <td><span>{{ GMTToStr(v.ct_time) }}</span></td>
                                                            <td><span>{{ v.amount }}</span></td>
                                                            <td><span>{{ v.address }}</span></td>
                                                            <td><span>{{ v.txHash }}</span></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="ant-table-placeholder">
                                                    <!--<div style="padding-top: 140px;"></div>-->
                                                    <Page :total="Number(rechargeCnt)" :page-size="request.pageSize"
                                                          v-show="rechargeList.length > 0"
                                                          @on-change="rechargeNext"></Page>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ant-card-body" v-show="recordActive == 'withdraw'">
                                <div class="filter___2AY3J">
                                    <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                        <div class="label___1yE6x">{{ $t('m.order.time[3]') }}</div>
                                        <div class="kcRangePicker___3QFSs">
                                            <span class="ant-calendar-picker ant-calendar-picker-small">
                                                <el-date-picker
                                                    v-model="timeRange2"
                                                    type="daterange"
                                                    @blur="timeSearch()"
                                                    unlink-panels
                                                    :range-separator="$t('m.order.text[1]')"
                                                    :start-placeholder="$t('m.order.text[0]')"
                                                    :end-placeholder="$t('m.order.text[2]')">
                                                </el-date-picker>
                                            </span>
                                            <div class="miniDivider___Wh7bp ant-divider ant-divider-vertical"></div>
                                            <div
                                                class="ant-radio-group ant-radio-group-solid filter-radio-button kc-radio-group">
                                                <label class="kc-radio-btn ant-radio-button-wrapper"
                                                       :class="timeActive2 == 'day' ? 'ant-radio-button-wrapper-checked' : ''"
                                                       @click="timeSearch2('day')">
                                                    <span>{{ $t('m.order.time[1]') }}</span>
                                                </label>
                                                <label class="kc-radio-btn ant-radio-button-wrapper"
                                                       :class="timeActive2 == 'month' ? 'ant-radio-button-wrapper-checked' : ''"
                                                       @click="timeSearch2('month')">
                                                    <span>{{ $t('m.order.time[2]') }}</span>
                                                </label>
                                                <!--<label class="kc-radio-btn ant-radio-button-wrapper" :class="timeActive == 'threeMonth' ? 'ant-radio-button-wrapper-checked' : ''" @click="timeActive = 'threeMonth'">
                                                    <span>3个月</span>
                                                </label>
                                                <label class="kc-radio-btn ant-radio-button-wrapper" :class="timeActive == 'oneYear' ? 'ant-radio-button-wrapper-checked' : ''" @click="timeActive = 'oneYear'">
                                                    <span>1年</span>
                                                </label>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                        <div class="label___1yE6x">{{ $t('m.assets.status[0]') }}</div>
                                        <div
                                            class="ant-radio-group ant-radio-group-solid filter-radio-button kc-radio-group">
                                            <label class="kc-radio-btn ant-radio-button-wrapper"
                                                   :class="request2.status == '' ? 'ant-radio-button-wrapper-checked' : ''"
                                                   @click="changeStatus('')">
                                                <span
                                                    style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{
                                                        $t('m.assets.status[1]')
                                                    }}</span>
                                            </label>
                                            <label class=" kc-radio-btn ant-radio-button-wrapper"
                                                   :class="request2.status == '0' ? 'ant-radio-button-wrapper-checked' : ''"
                                                   @click="changeStatus('0')">
                                                <span
                                                    style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.assets.status[5]') }}</span>
                                            </label>
                                            <label class=" kc-radio-btn ant-radio-button-wrapper"
                                                   :class="request2.status == '1' ? 'ant-radio-button-wrapper-checked' : ''"
                                                   @click="changeStatus('1')">
                                                <span
                                                    style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.assets.status[6]') }}</span>
                                            </label>
                                            <label class=" kc-radio-btn ant-radio-button-wrapper"
                                                   :class="request2.status == '2' ? 'ant-radio-button-wrapper-checked' : ''"
                                                   @click="changeStatus('2')">
                                                <span
                                                    style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.assets.status[7]') }}</span>
                                            </label>
                                            <label class=" kc-radio-btn ant-radio-button-wrapper"
                                                   :class="request2.status == '3' ? 'ant-radio-button-wrapper-checked' : ''"
                                                   @click="changeStatus('3')">
                                                <span
                                                    style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.assets.status[8]') }}</span>
                                            </label>
                                            <label class=" kc-radio-btn ant-radio-button-wrapper"
                                                   :class="request2.status == '4' ? 'ant-radio-button-wrapper-checked' : ''"
                                                   @click="changeStatus('4')">
                                                <span
                                                    style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.assets.status[9]') }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                        <div class="label___1yE6x">{{ $t('m.assets.table[0]') }}</div>
                                        <div class=" kc-select  ant-select ant-select-enabled ant-select-allow-clear"
                                             style="width: 100px;background-color: #fff">
                                            <div class="ant-select-selection ant-select-selection--single"
                                                 @click="currencyShow = !currencyShow">
                                                <div class="ant-select-selection__rendered">
                                                    <div class="ant-select-selection__placeholder"
                                                         style="display: block; opacity: 1;height: 24px;line-height: 24px">
                                                        {{
                                                            currencyName2 == '' ? $t('m.assets.status[1]') :
                                                                currencyName2
                                                        }}
                                                    </div>
                                                    <div class="ant-select-search ant-select-search--inline"
                                                         style="display: none;">
                                                        <div class="ant-select-search__field__wrap">
                                                            <input type="text" class="ant-select-search__field">
                                                            <span class="ant-select-search__field__mirror"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="ant-select-arrow" style="user-select: none;">
                                                <i class="ant-select-arrow-icon"></i>
                                            </span>
                                            </div>
                                            <div class="currency-container" v-if="currencyShow">
                                                <div class="currency-list" v-for="(v,k) in currencyAll" :key="k"
                                                     @click="currencyChange2(v.currency_name, v.id)">{{
                                                        v.currency_name
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ant-table-wrapper table___3RU8w ">
                                    <div class="ant-spin-nested-loading">
                                        <div class="ant-spin-container">
                                            <div
                                                class="ant-table ant-table-default ant-table-empty ant-table-scroll-position-left">
                                                <div class="ant-table-body">
                                                    <table>
                                                        <thead class="ant-table-thead">
                                                        <tr>
                                                            <th style="width: 100px;">
                                                                <span>{{ $t('m.assets.table[0]') }}</span>
                                                            </th>
                                                            <th style="width: 120px">
                                                                <span>{{ $t('m.assets.table[1]') }}</span>
                                                            </th>
                                                            <th style="width: 160px">
                                                                <span>{{ $t('m.assets.table[2]') }}</span>
                                                            </th>
                                                            <th>
                                                                <span>{{ $t('m.assets.table[6]') }}</span>
                                                            </th>
                                                            <!-- <th>
                                                                 <span>{{ $t('m.assets.table[3]') }}</span>
                                                             </th>-->
                                                            <th style="width: 130px">
                                                                <span>{{ $t('m.assets.table[4]') }}</span>
                                                                <!--<div class="record-icon">
                                                                    ?
                                                                    <div class="record-warning">
                                                                        <div>{{ $t('m.assets.text[7]') }}</div>
                                                                        <i></i>
                                                                    </div>
                                                                </div>-->
                                                            </th>
                                                            <th>
                                                                <span>{{ $t('m.assets.table[25]') }}</span>
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="ant-table-tbody">
                                                        <tr v-for="(v,k) in extractList" :key="k"
                                                            v-show="request2.status == v.status || request2.status == ''">
                                                            <td><span>{{ v.currency_name }}</span></td>
                                                            <td><span>{{ GMTToStr(v.ct_time) }}</span></td>
                                                            <td><span>{{ v.amount }}</span></td>
                                                            <td><span>{{ v.to }}</span></td>
                                                            <!--<td><span>{{ v.txHash }}</span></td>-->
                                                            <td>
                                                                <span
                                                                    v-if="v.status == '0'">{{ $t('m.assets.status[5]') }}</span>
                                                                <span
                                                                    v-else-if="v.status == '1'">{{ $t('m.assets.status[6]') }}</span>
                                                                <span
                                                                    v-else-if="v.status == '2'">{{ $t('m.assets.status[7]') }}</span>
                                                                <span
                                                                    v-else-if="v.status == '3'">{{ $t('m.assets.status[8]') }}</span>
                                                                <span v-else>{{ $t('m.assets.status[9]') }}</span>
                                                            </td>
                                                            <td>{{ v.remark }}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="ant-table-placeholder">
                                                    <Page :total="Number(extractCnt)" :page-size="request2.pageSize"
                                                          v-show="extractList.length > 0"
                                                          @on-change="extractNext"></Page>
                                                    <!--<div style="padding-top: 140px;"></div>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
import Top from '@/components/top'
import Bottom from '@/components/bottom'

export default {
    name: "record",
    components: {
        Top, Bottom
    },
    mounted() {
        let account = this.$route.query.mobile ? this.$route.query.mobile : this.$route.query.email;
        let type = this.$route.query.mobile ? 2 : 1;
        let uid = Number(this.$route.query.uid);
        let login = this.$route.query.login;
        if (login) {
            this.doLogin(account, type, uid);
        }
        setTimeout(() => {
            this.getRecharge();
            this.getExtract();
        }, 1000);
    },
    data() {
        return {
            active: 'record',
            timeActive: 'month',
            timeActive2: 'month',
            recordActive: 'recharge',
            timeRange: [], // 时间范围选择
            timeRange2: [], // 时间范围选择
            currencyShow: false,
            currencyName: "",
            currencyName2: "",
            rechargeList: [],
            rechargeCnt: 0,
            extractList: [],
            extractCnt: 0,
            request: {
                pageNo: 1,
                pageSize: 10,
                timeBegin: "",
                timeEnd: "",
                currency_id: ""
            },
            request2: {
                pageNo: 1,
                pageSize: 10,
                timeBegin: "",
                timeEnd: "",
                status: '',
                currency_id: ""
            }
        }
    },
    methods: {
        doLogin(account, type, uid) {
            let paramData = this.signRequestLogin({
                account: account,
                enum: type,
                uid: uid,
                deviceCode: this.deviceCode.code,
                userAgent: this.deviceCode.userAgent
            });
            paramData.signature = this.signature(paramData);
            this.$axios.post(this.requestConfig.host + "/index/Login/login", paramData).then((res) => {
                return this.checkResponse(res);
            }).then((res) => {
                this.aUserInfo(res);
            })
        },
        changeTab: function (url, path) {
            this.active = path;
            this.changeRoute(url);
        },
        timeSearch() {
            if (this.recordActive == 'recharge') {
                if (this.timeRange.length == 0) return;
                this.request.timeBegin = new Date(this.timeRange[0]).getTime() / 1000;
                this.request.timeEnd = new Date(this.timeRange[1]).getTime() / 1000;
                this.getRecharge();
            } else {
                if (this.timeRange2.length == 0) return;
                this.request2.timeBegin = new Date(this.timeRange2[0]).getTime() / 1000;
                this.request2.timeEnd = new Date(this.timeRange2[1]).getTime() / 1000;
                this.getExtract();
            }
        },
        timeSearch2(v) {
            if (this.recordActive == 'recharge') {
                this.timeActive = v;
                this.request.timeEnd = new Date().getTime() / 1000;
                console.log(this.request.timeEnd);
                switch (v) {
                    case "day":
                        this.request.timeBegin = new Date(new Date().toLocaleDateString()).getTime() / 1000;
                        break;
                    case "month":
                        this.request.timeBegin = new Date(new Date().toLocaleDateString()).getTime() / 1000 - 30 * 24 * 60 * 60;
                        break;
                }
                this.getRecharge();
            } else {
                this.timeActive2 = v;
                this.request2.timeEnd = new Date().getTime() / 1000;
                switch (v) {
                    case "day":
                        this.request2.timeBegin = new Date(new Date().toLocaleDateString()).getTime() / 1000;
                        break;
                    case "month":
                        this.request2.timeBegin = new Date(new Date().toLocaleDateString()).getTime() / 1000 - 30 * 24 * 60 * 60;
                        break;
                }
                this.getExtract();
            }
        },
        getRecharge() {
            this.rechargeList = [];
            let paramData = {
                currency_id: this.request.currency_id,
                pageNo: this.request.pageNo,
                pageSize: this.request.pageSize,
                timeBegin: this.request.timeBegin,
                timeEnd: this.request.timeEnd,
            };
            paramData.signature = this.signature(paramData);
            this.$axios.get(this.requestConfig.host + "/index/Recharge/rechargeList?token=" + this.userInfo.key, {
                params: paramData,
            }).then((res) => {
                return this.checkResponse(res);
            }).then((res) => {
                this.aLoadV({show: false});
                this.rechargeList = res.list;
                this.rechargeCnt = res.cnt;
            }).catch((e) => {
                if (e == 20001) return;
                console.log(e);
                this.aLoadV({show: false});
            })
        },
        getExtract () {
            this.extractList = [];
            let paramData = {
                currency_id: this.request2.currency_id,
                pageNo: this.request2.pageNo,
                pageSize: this.request2.pageSize,
                timeBegin: this.request2.timeBegin,
                timeEnd: this.request2.timeEnd,
            };
            paramData.signature = this.signature(paramData);
            this.$axios.get(this.requestConfig.host + "/index/Recharge/extractList?token=" + this.userInfo.key, {
                params: paramData,
            }).then((res) => {
                return this.checkResponse(res);
            }).then((res) => {
                this.aLoadV({show: false});
                this.extractList = res.list;
                this.extractCnt = res.cnt;
            }).catch((e) => {
                if (e == 20001) return;
                console.log(e);
                this.aLoadV({show: false});
            })
        },
        changeStatus: function (status) {
            this.request2.status = status;
            this.getExtract();
        },
        currencyChange: function (name, id) {
            this.currencyName = name;
            this.request.currency_id = id;
            this.currencyShow = false;
            this.getRecharge();
        },
        currencyChange2: function (name, id) {
            this.currencyName2 = name;
            this.request2.currency_id = id;
            this.currencyShow = false;
            this.getExtract();
        },
        rechargeNext(pageNo) {
            this.request.pageNo = pageNo;
            this.getRecharge();
        },
        extractNext(pageNo) {
            this.request2.pageNo = pageNo;
            this.getExtract();
        },
    }
}
</script>

<style lang="scss">
@import "../../assets/css/record.scss";

.ivu-page a {
    float: none;
}
</style>
